// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"1fa280dc","389":"a9bfa4d1"}[chunkId] + ".chunk.js";
};